import React from "react"
import autobind from "class-autobind"
import { Dialog, FlatButton, TextField, IconButton, FontIcon, Toggle } from "material-ui"
import FinddDatePicker from "../../../common/FinddDatePicker"
import strings from "../../../../localization/strings"
import { EScheduleListType, IClientDocument, IJobDocument, IScheduleConstraint, IScheduleDocument, IScheduleTemplate, IDate } from "../../../../models"
import AccountStore from "../../../../stores/AccountStore"
import HierarchySettingsStore from "../../../../stores/HierarchySettingsStore"
import SelectTemplate from "./SelectTemplate"
import moment from "moment"
import * as utils from "../../../../helpers/utils"
import * as scheduleHelper from "../../../../helpers/scheduleHelper"
import * as api from "../../../../api"
import _ from "lodash"
import { blueGrey500, red500 } from "material-ui/styles/colors"
import ScheduleConstraintsTable from "../../constraints/ScheduleConstraintsTable"
import ChooseHierarchyJobChip from "../../../hierarchy/choose_hierarchy/ChooseHierarchyJobChip"
import { checkJobFieldAvailable } from "../../../../helpers/jobHelper"
import AppStateStore from "../../../../stores/AppStateStore"

interface IProps {
  type: EScheduleListType
  startDate: string //it's local time
  handleClose(): void
  handleAdd(schedule: IScheduleDocument): void

  // for job->Schedule
  job: IJobDocument
  // for cient->Schedule
  client: IClientDocument
}
interface IState {
  name: string
  errorName: string
  description: string
  selectedTemplate: IScheduleTemplate | IScheduleDocument
  checkingValidateNameDates: boolean
  periodDays: number
  errorPeriodDays: string
  startDate: IDate
  errorStartDate: string
  overrideHierarchy: boolean
  masterScheduleActive: boolean
  masterScheduleInAdvanceDays: number
  errorMasterScheduleInAdvanceDays: string
  scheduleConstraints: IScheduleConstraint[]
  job: IJobDocument
  excludeWeekends: boolean
  autoPostAsSchedulePlanner: boolean
}

export default class AddScheduleDialog extends React.Component<IProps, IState> {
  private FinddDatePicker
  private hierarchyId
  constructor(props: IProps) {
    super(props)
    this.hierarchyId = props.type === EScheduleListType.ClientSchedule ?
      props.client.HierarchyId :
      props.type === EScheduleListType.JobSchedule ?
        props.job.HierarchyId :
        HierarchySettingsStore.getGlobalLevelItemFilterId() ? HierarchySettingsStore.getGlobalLevelItemFilterId() : null
    this.state = {
      name: "",
      errorName: "",
      description: "",
      selectedTemplate: null,
      checkingValidateNameDates: false,
      periodDays: 7,
      errorPeriodDays: "",
      startDate: moment(props.startDate).startOf("day"),
      errorStartDate: "",
      overrideHierarchy: true,
      masterScheduleActive: true,
      masterScheduleInAdvanceDays: 1,
      errorMasterScheduleInAdvanceDays: "",
      scheduleConstraints: [],
      job: props.type === EScheduleListType.JobSchedule && props.job ? props.job : null,
      excludeWeekends: false,
      autoPostAsSchedulePlanner: false,
    }
    autobind(this)
  }

  async handleSave() {
    //scheduleHelper.udpateDailyBudgets(this.state.startDate, _.cloneDeep(this.state.selectedTemplate)["Budget"])
    //return

    const validate = await this.checkValidate()
    if (!validate) return
    let payload: IScheduleDocument
    if (this.state.selectedTemplate) {
      const selectedTemplate = _.cloneDeep(this.state.selectedTemplate)
      const schedules = scheduleHelper.updateVirtualTimePatternTemplates(
        moment(this.state.startDate).startOf("day").utc(true).format(),
        selectedTemplate.StartDate,
        selectedTemplate.hasOwnProperty("AccountId") ? (selectedTemplate as IScheduleDocument).Schedules : (selectedTemplate as IScheduleTemplate).PatternTemplates
      )
      payload = {
        Id: utils.guid(),
        Name: this.state.name.trim(),
        Description: this.state.description,
        HierarchyId: this.hierarchyId,
        JobId: this.state.job ? this.state.job.Id : null,
        JobName: this.state.job ? this.state.job.Name : null,
        ClientId: this.props.client ? this.props.client.Id : null,
        AccountId: AccountStore.getCurrentAccount().Id,
        StartDate: moment(this.state.startDate).startOf("day").utc(true).format(),
        EndDate: moment(this.state.startDate).add(this.state.periodDays - 1, "day").endOf("day").utc(true).format(),
        Schedules: (this.state.overrideHierarchy || this.props.job || this.props.client) ?
          scheduleHelper.overridePatternTemplatesHierarchy(
            schedules,
            this.hierarchyId,
            this.state.job,
            this.props.client
          ) :
          schedules,
        Budget: AccountStore.getCRMEnabled() ? scheduleHelper.udpateDailyBudgets(this.state.startDate, selectedTemplate["Budget"]) : null,
        Summary: selectedTemplate["Summary"],
        ExcludeWeekends: this.state.excludeWeekends
      }
    }
    else {
      payload = {
        Id: utils.guid(),
        Name: this.state.name.trim(),
        Description: this.state.description,
        HierarchyId: this.hierarchyId,
        JobId: this.state.job ? this.state.job.Id : null,
        JobName: this.state.job ? this.state.job.Name : null,
        ClientId: this.props.client ? this.props.client.Id : null,
        AccountId: AccountStore.getCurrentAccount().Id,
        StartDate: moment(this.state.startDate).startOf("day").utc(true).format(),
        EndDate: moment(this.state.startDate).add(this.state.periodDays - 1, "day").endOf("day").utc(true).format(),
        ExcludeWeekends: this.state.excludeWeekends
      }
    }

    if (this.props.type === EScheduleListType.Master) {
      payload.MasterSchedule = true
      payload.MasterScheduleActive = this.state.masterScheduleActive
      payload.InAdvanceDays = this.state.masterScheduleInAdvanceDays
      payload.AutoPostAsPlanner = this.state.autoPostAsSchedulePlanner
    }

    AppStateStore.setProgressSnackbarContent("loading")
    const newScheduleValidate = await api.getValidationForNewSchedule(payload)
    AppStateStore.setProgressSnackbarContent(null)
    const scheduleConstraints = newScheduleValidate.data as IScheduleConstraint[]
    scheduleConstraints.length ?
      this.setState({ scheduleConstraints: scheduleConstraints }) :
      this.props.handleAdd(payload)
  }

  checkValidate() {
    let isValidate = true
    if (!this.state.name.trim()) {
      this.setState({ errorName: strings.NameRequired })
      isValidate = false
    }
    else {
      this.setState({ errorName: "" })
    }

    if (!this.state.periodDays) {
      this.setState({ errorPeriodDays: strings.This_field_is_required })
      isValidate = false
    }
    else if (Number(this.state.periodDays) < 1 || Number(this.state.periodDays) > 31) {
      this.setState({ errorPeriodDays: strings.formatString(strings.This_field_requires_a_number_between_min_and_max, 1, 31) as string })
      isValidate = false
    }
    else {
      this.setState({ errorPeriodDays: "" })
    }

    if (!this.state.masterScheduleInAdvanceDays) {
      this.setState({ errorMasterScheduleInAdvanceDays: strings.This_field_is_required })
      isValidate = false
    }
    else if (Number(this.state.masterScheduleInAdvanceDays) < 1) {
      this.setState({ errorMasterScheduleInAdvanceDays: strings.formatString(strings.This_field_must_be_greater_than_or_equal_to_x, 1) as string })
      isValidate = false
    }
    else {
      this.setState({ errorMasterScheduleInAdvanceDays: "" })
    }


    return new Promise(resolve =>
      !isValidate ?
        resolve(false) :
        this.setState({ checkingValidateNameDates: true }, () => {
          const accountId = AccountStore.getCurrentAccount().Id
          const jobId = this.state.job ? this.state.job.Id : ""
          const startDate = moment(this.state.startDate).startOf("day").utc(true).format()
          const endDate = moment(this.state.startDate).add(this.state.periodDays - 1, "day").endOf("day").utc(true).format()
          const isMasterSchedule = this.props.type === EScheduleListType.Master
          Promise.all([
            api.checkValidateScheduleName(accountId, this.hierarchyId ? this.hierarchyId : "", jobId, startDate, endDate, this.state.name.trim(), isMasterSchedule),
            api.checkValidateScheduleDates(accountId, jobId, startDate, endDate, isMasterSchedule)
          ])
            .then(res => {
              const checkValidateName = res[0].data
              const checkValidateDates = res[1].data as IScheduleConstraint
              this.setState({
                checkingValidateNameDates: false,
                errorName: checkValidateName ? "" : strings.Schedule_name_is_duplicated_for_this_week,
                errorStartDate: checkValidateDates ? checkValidateDates.Note : ""
              })

              resolve(checkValidateName && !checkValidateDates ? true : false)
            })
        })
    )
  }

  render() {
    return (
      <Dialog
        open
        autoScrollBodyContent
        title={this.props.type === EScheduleListType.Master ? strings.Add_New_Master_Schedule : strings.Add_New_Schedule_Planner}
        titleStyle={{ paddingLeft: 35, paddingBottom: 10 }}
        actions={[
          <FlatButton
            data-intercom-target={"AddSchedule-Btn-CloseAddScheduleDialog"}
            label={strings.CANCEL}
            secondary
            onClick={this.props.handleClose}
          />,
          <FlatButton
            data-intercom-target={"AddSchedule-Btn-SaveSchedule"}
            label={strings.SAVE}
            primary
            disabled={this.state.checkingValidateNameDates}
            onClick={this.handleSave}
          />
        ]}
      >
        <div style={{ paddingRight: 20, paddingLeft: 20 }}>
          <div style={{ position: "absolute", top: 30, right: 50, fontWeight: 500 }}>
            {this.state.periodDays > 1 ?
              `${moment(this.state.startDate).format("ddd MMM. DD, YYYY")} - ${moment(this.state.startDate).add(this.state.periodDays - 1, "day").format("ddd MMM. DD, YYYY")}` :
              `${moment(this.state.startDate).format("ddd MMM. DD, YYYY")}`
            }
          </div>
          <div>
            <ChooseHierarchyJobChip
              readonlyHierarchy
              readonlyJob={this.props.type === EScheduleListType.JobSchedule}
              hideJob={!AccountStore.getJobsEnabled()}
              hierarchyChipLabel={strings.HierarchyLevel}
              jobChipLabel={checkJobFieldAvailable('singular') ? `${AccountStore.getCurrentAccountSettings().CustomFieldSettings.JobFieldLabels.SingularJobLabel}` : strings.Job}
              hierarchyItemId={this.hierarchyId}
              jobId={this.state.job ? this.state.job.Id : null}
              hieararchyChipMaxWidth={700}
              jobChipMaxWidth={700}
              handleSelectHierarchyJob={(hierarchyItemId: string, job: IJobDocument) => {
                this.setState({ job }, () => this.checkValidate())
              }}
            />
          </div>
          <Toggle
            data-intercom-target={"AddSchedule-Toggle-OverrideHierarchy"}
            label={strings.Override_hierarchy}
            toggled={this.state.overrideHierarchy}
            style={{ width: 225, marginTop: 25 }}
            onToggle={(e, value) => this.setState({ overrideHierarchy: value, selectedTemplate: null })}
          />
          <SelectTemplate
            masterSchedule={this.props.type === EScheduleListType.Master}
            overrideHierarchy={this.state.overrideHierarchy}
            hierarchyId={this.hierarchyId}
            jobId={this.props.type === EScheduleListType.JobSchedule ? this.props.job.Id : null}
            selectedTemplate={this.state.selectedTemplate}
            handleSelect={selectedTemplate =>
              this.setState({
                selectedTemplate,
                name: selectedTemplate.Name,
                periodDays: scheduleHelper.getDayLengthFromStartAndEndTime(selectedTemplate.StartDate, selectedTemplate.EndDate),
                excludeWeekends: selectedTemplate.ExcludeWeekends
              }, () => this.checkValidate())
            }
          />
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <div style={{ position: "relative" }}>
              <FinddDatePicker
                data-intercom-target={"AddSchedule-Select-ScheduleStartDate"}
                ref={elem => this.FinddDatePicker = elem}
                floatingLabelText={strings.Schedule_Start_Date}
                value={moment(this.state.startDate).toDate()}
                formatDate={date => moment(date).format("ddd MMM. DD, YYYY")}
                onChange={(e, date: Date) => this.setState({ startDate: moment(date).startOf("day") }, () => this.checkValidate())}
                cancelLabel={<span style={{ color: blueGrey500 }}>{strings.Cancel}</span>}
                firstDayOfWeek={0}
                errorText={this.state.errorStartDate}
              />
              <IconButton
                data-intercom-target={"AddSchedule-Btn-OpenScheduleStartDatePicker"}
                onTouchTap={() => this.FinddDatePicker.DatePicker.openDialog()}
                tooltip={"Pick a date"}
                style={{ position: "absolute", right: 0, top: 20 }}
              >
                <FontIcon className="fa fa-calendar fa-lg" />
              </IconButton>
            </div>
            <TextField
              data-intercom-target={"AddSchedule-Entry-SchedulePeriodDays"}
              floatingLabelText={strings.Schedule_Period_Days}
              value={this.state.periodDays}
              disabled={this.state.selectedTemplate !== null}
              onChange={(e, value) => utils.validateInteger(value) && this.setState({ periodDays: value }, () => this.checkValidate())}
              errorText={this.state.errorPeriodDays}
              errorStyle={{ position: "absolute", bottom: -10 }}
            />
          </div>
          {this.props.type === EScheduleListType.Master &&
            <div>
              <div style={{ display: "flex", justifyContent: "space-between", marginTop: 30 }}>
                <Toggle
                  data-intercom-target={"AddSchedule-Toggle-MasterScheduleActive"}
                  label={strings.Master_Schedule_Active}
                  toggled={this.state.masterScheduleActive}
                  style={{ width: 250 }}
                  onToggle={(e, value) => this.setState({ masterScheduleActive: value })}
                />
                <Toggle
                  data-intercom-target={"AddSchedule-Toggle-MasterSchedule-PostState"}
                  label={strings.Post_as_Posted_Schedule}
                  toggled={!this.state.autoPostAsSchedulePlanner}
                  style={{ width: 250 }}
                  onToggle={(e, value) => this.setState({ autoPostAsSchedulePlanner: !value })}
                />
              </div>
              <TextField
                data-intercom-target={"AddSchedule-Entry-PostScheduleInAdvanceDays"}
                floatingLabelText={strings.Post_Schedules_In_Advance_Days}
                value={this.state.masterScheduleInAdvanceDays}
                onChange={(e, value) => utils.validateInteger(value) && this.setState({ masterScheduleInAdvanceDays: value }, () => this.checkValidate())}
                errorText={this.state.errorMasterScheduleInAdvanceDays}
                errorStyle={{ position: "absolute", bottom: -10 }}
              />
            </div>
          }
          <TextField
            data-intercom-target={"AddSchedule-Entry-Name"}
            floatingLabelText={strings.Name}
            value={this.state.name}
            onChange={(e, value) => { this.setState({ name: value }, () => this.checkValidate()) }}
            errorText={this.state.errorName}
            errorStyle={{ position: "absolute", bottom: -10 }}
            fullWidth={true}
          />
          <TextField
            data-intercom-target={"AddSchedule-Entry-Description"}
            floatingLabelText={strings.Description}
            value={this.state.description}
            onChange={(e, value) => { this.setState({ description: value }) }}
            fullWidth={true}
          />
          <Toggle
            data-intercom-target={"AddSchedule-Toggle-ExcludeWeekends"}
            label={strings.Exclude_Weekends}
            toggled={this.state.excludeWeekends}
            style={{ width: 225, marginTop: 25 }}
            onToggle={(e, value) => this.setState({ excludeWeekends: value })}
          />
        </div>
        {this.state.scheduleConstraints.length > 0 &&
          <div style={{ marginTop: 25 }}>
            <span style={{ color: red500 }}>{strings.Validation_Error}</span>
            <ScheduleConstraintsTable
              constraints={this.state.scheduleConstraints}
            />
          </div>
        }
      </Dialog>
    )
  }
}